"use client";

import { useEffect } from "react";

const STORAGE_KEY = "inarax:last_purchase";

export default function CheckoutSuccessNotifier({ courseUuid }: { courseUuid: string }) {
  useEffect(() => {
    const payload = {
      courseUuid,
      ts: Date.now(),
    };

    // Cross-tab signal (storage event fires in *other* tabs)
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch {
      // ignore
    }

    // Same-origin cross-tab broadcast (more reliable than storage in some browsers)
    try {
      const bc = new BroadcastChannel("inarax:purchases");
      bc.postMessage(payload);
      bc.close();
    } catch {
      // ignore
    }
  }, [courseUuid]);

  return null;
}

